<template>
    <div>
        <h2>Supsis Whatsapp Integration Agreement</h2>
        <span> Please read agreement and click on the button below to accept it. </span>

        <p>
            WhatsApp Terms Of Service Last modified: January 28, 2020 (archived versions) If you live in the European
            Region, WhatsApp Ireland Limited provides WhatsApp to you under this Terms of Service and Privacy Policy.
            WhatsApp LLC (“WhatsApp,” “our,” “we,” or “us”) provides messaging, Internet calling, and other services to
            users around the world. Please read our Terms of Service so you understand what’s up with your use of
            WhatsApp.
        </p>
        <p>
            You agree to our Terms of Service (“Terms”) by installing, accessing, or using our apps, services, features,
            software, or website (together, “Services”). NO ACCESS TO EMERGENCY SERVICES: There are important
            differences between WhatsApp and your mobile and fixed-line telephone and SMS services. Our Services do not
            provide access to emergency services or emergency services providers, including the police, fire
            departments, or hospitals, or otherwise connect to public safety answering points. You should ensure you can
            contact your relevant emergency services providers through a mobile, fixed-line telephone, or other service.
            IF YOU ARE A WHATSAPP USER LOCATED IN THE UNITED STATES OR CANADA, OUR TERMS CONTAIN A BINDING ARBITRATION
            PROVISION, WHICH STATES THAT, EXCEPT IF YOU OPT OUT AND EXCEPT FOR CERTAIN TYPES OF DISPUTES, WHATSAPP AND
        </p>
        <p>
            YOU AGREE TO RESOLVE ALL DISPUTES THROUGH BINDING INDIVIDUAL ARBITRATION, WHICH MEANS THAT YOU WAIVE ANY
            RIGHT TO HAVE THOSE DISPUTES DECIDED BY A JUDGE OR JURY, AND THAT YOU WAIVE YOUR RIGHT TO PARTICIPATE IN
            CLASS ACTIONS, CLASS ARBITRATIONS, OR REPRESENTATIVE ACTIONS. PLEASE READ THE “SPECIAL ARBITRATION PROVISION
            FOR UNITED STATES OR CANADA USERS” SECTION BELOW TO LEARN MORE. Back to top About our services Registration.
            You must register for our Services using accurate data, provide your current mobile phone number, and, if
            you change it, update this mobile phone number using our in-app change number feature. You agree to receive
            text messages and phone calls (from us or our third-party providers) with codes to register for our
            Services. Address Book. You provide us the phone numbers of WhatsApp users and your other contacts in your
            mobile phone address book on a regular basis. You confirm you are authorized to provide us such numbers to
            allow us to provide our Services. Age. You must be at least 13 years old to use our Services (or such
            greater age required in your country for you to be authorized to use our Services without parental
            approval). In addition to being of the minimum required age to use our Services under applicable law, if you
            are not old enough to have authority to agree to our Terms in your country, your parent or guardian must
            agree to our Terms on your behalf. Devices and Software. You must provide certain devices, software, and
            data connections to use our Services, which we otherwise do not supply. For as long as you use our Services,
            you consent to downloading and installing updates to our Services, including automatically. Fees and Taxes.
            You are responsible for all carrier data plan and other fees and taxes associated with your use of our
            Services. We may charge you for our Services, including applicable taxes. We may refuse or cancel orders. We
            do not provide refunds for our Services, except as required by law.
        </p>

        <div class="d-flex justify-content-end">
            <a-button type="primary" @click="agree">
                {{ $t("wp.readAndAgree") }}
            </a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Agreement",
    methods: {
        agree() {
            localStorage.setItem("wp-agreement-accepted", "true");
            this.$emit("agree");
        },
    },
};
</script>

<style scoped></style>
